(function($) {
  // 等待 DOM 加载完成
  $(document).ready(function() {
    // 找到所有带有 j-hover-class 类的元素
    $('.j-hover-class').each(function() {
      const $element = $(this);
      // 获取 data-class 属性值
      const hoverClass = $element.data('class');

      if (!hoverClass) return; // 如果没有定义 data-class，则跳过

      // 监听 mouseenter 事件
      $element.on('mouseenter', function() {
        $(this).addClass(hoverClass);
      });

      // 监听 mouseleave 事件
      $element.on('mouseleave', function() {
        $(this).removeClass(hoverClass);
      });
    });
  });
})(jQuery);